import { render, staticRenderFns } from "./new.vue?vue&type=template&id=e96843c8&scoped=true"
import script from "./new.vue?vue&type=script&lang=js"
export * from "./new.vue?vue&type=script&lang=js"
import style0 from "./new.vue?vue&type=style&index=0&id=e96843c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e96843c8",
  null
  
)

export default component.exports